



















import Component, { mixins } from 'vue-class-component';
import BasePageMixin from '@/mixins/base-page-mixin';
import { CategoryItem } from '@/interfaces/category-item';
import IndicatorServices, { IndicatorDto } from '@/services/indicator';
import { confirmDelete } from '@/libs/decorator';
import ApproveModal from '../../components/approve-modal.vue';
import { Watch } from 'vue-property-decorator';
import { State } from 'vuex-class';
import IndicatorSetServices from '@/services/indicatorSet';

@Component({
  components: { ApproveModal }
})
export default class Indicator extends mixins(BasePageMixin) {
  bread = [{ name: '指标库' }];
  indSetCode: any = '';
  indSrv = new IndicatorServices();

  menu: CategoryItem[] = [
    {
      title: '指标集',
      icon: 'fa-cube',
      expand: true,
      oprate: [
        { name: '新建指标', icon: 'fa-compass', permissionKey: 'IND_ADD', key: 'addRoot' },
        { name: '刷新', icon: 'fa-refresh', key: 'refresh' }
      ],
      children: []
    }
  ];

  created() {
    this.indSetCode = this.$route.query.indSetCode;
  }

  setSrv = new IndicatorSetServices();
  async getSetInfo() {
    let id: any = this.$route.query.indSetId;
    if (!id) return false;
    let info = await this.setSrv.getInfo(id);
    this.bread = [{ name: '指标库' }, { name: info.indSetName }];
  }

  async getIndTree() {
    this.menu[0].loading = true;
    let list = await this.indSrv.getTree({ indSetCode_eq: this.indSetCode });
    this.menu[0].children = list.map((ind: IndicatorDto & { children: any }) => this.packTreeItem(ind));
    this.menu[0].loading = false;
    this.getSetInfo();
  }

  packTreeItem(ind: IndicatorDto & { children: any }) {
    return {
      title: ind.indName,
      key: this.getDetailUri(ind),
      icon: 'fa-compass',
      record: ind,
      expand: true,
      oprate: [
        { name: '编辑指标', icon: 'fa-edit', permissionKey: 'IND_UPD', key: 'edit' },
        { name: '新建子指标', icon: 'fa-compass', permissionKey: 'IND_ADD', key: 'addChild' },
        { name: '提交审批', icon: 'fa-share', permissionKey: 'IND_REQ', key: 'approve' },
        { name: '删除指标', icon: 'fa-trash', permissionKey: 'IND_DEL', key: 'remove' }
      ],
      children: (ind.children || []).map((ind: IndicatorDto & { children: any }) => this.packTreeItem(ind))
    };
  }

  getDetailUri = (ind: IndicatorDto) => `/decision/indicator/detail?id=${ind.id}&indSetCode=${ind.indSetCode}`;

  approveVisible: boolean = false;
  approveInfo: any = {};
  command(key: string, record: any) {
    let indSetCode = this.$route.query.indSetCode;
    switch (key) {
      case 'addRoot': // 新建
        this.replaceUrl(`/decision/indicator/add?indSetCode=${indSetCode}`);
        break;
      case 'addChild':
        this.replaceUrl(`/decision/indicator/add?parentIndCode=${record.indCode}&indSetCode=${indSetCode}`);
        break;
      case 'edit': // 编辑
        if (record.approveStatus == 2 || record.approveStatus == 3) {
          this.$message.error('当前状态不能编辑');
          return false;
        }
        this.replaceUrl(`/decision/indicator/edit?id=${record.id}&indSetCode=${indSetCode}`);
        break;
      case 'remove': // 删除
        if ([1, 2, 3, 7].includes(record.approveStatus)) {
          this.$message.error('当前状态不能删除');
          return false;
        }
        if ([4, 5].includes(record.approveStatus) && record.status == 0) {
          this.$message.error('当前状态不能删除');
          return false;
        }
        this.removeInd(record.id);
        break;
      case 'approve': // 审批
        if (record.approveStatus > 1) {
          this.$message.error('当前状态不能提交审批');
          return false;
        }
        this.approveInfo = { type: 1, code: record.indCode, approveStatus: record.approveStatus, uri: this.getDetailUri(record) };
        this.approveVisible = true;
        break;
      case 'link':
        this.replaceUrl(record);
        break;
      case 'refresh':
        this.reloadMenu();
      default:
        break;
    }
  }

  @State RELOAD_IND_MENU: any;
  @Watch('RELOAD_IND_MENU')
  reloadMenu() {
    this.getIndTree();
  }

  @confirmDelete()
  async removeInd(id: number) {
    let res = await this.indSrv.remove(id);
    if (!res) return false;
    this.$message.success('操作成功');
    this.reloadMenu();
    this.onDeleteRemoveTab('indicator', id);
  }

  @Watch('$route')
  onRouteChange() {
    if (/\/decision\/indicator/.test(this.$route.path)) {
      this.indSetCode = this.$route.query.indSetCode;
    }
  }

  @Watch('indSetCode')
  async onIdChange() {
    this.getIndTree();
  }
}
